import { forwardRef } from "react";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { Account } from "../../../types";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { DataGrid } from "devextreme-react";

export const renderInformationItem = (item: any) => {
  if (item.editorOptions.value !== null) {
    return <span>{item.editorOptions.value}</span>;
  } else {
    return <span>-</span>;
  }
};

const DetailAccountForm = forwardRef<any, { data: Account }>(
  ({ data }, ref) => {
    const localize = useSelector(getLocalized);
    const accountLocationColums = [
      {
        dataField: "LocationTitle",
        caption: localize.getString("locationtitle"),
      },
      {
        dataField: "Country",
        caption: localize.getString("country"),
      },
      {
        dataField: "City",
        caption: localize.getString("city"),
      },
      {
        dataField: "District",
        caption: localize.getString("district"),
      },
      {
        dataField: "SubDistrict",
        caption: localize.getString("subdistrict"),
      },
      {
        dataField: "Neighbourhood",
        caption: localize.getString("neighbourhood"),
      },
    ];
    return (
      <form>
        <Form
          ref={ref}
          key="id"
          labelLocation="left"
          formData={data}
          showColonAfterLabel={true}
        >
          <GroupItem>
            <GroupItem
              colCount={2}
              caption={localize.getString("accountdetails")}
            >
              <SimpleItem
                dataField="AccountRoles[0].AccountRole"
                label={{
                  text: localize.getString("accountrole"),
                }}
                render={renderInformationItem}
              />
              <SimpleItem
                dataField="AccountType"
                label={{
                  text: localize.getString("accounttype"),
                }}
                render={renderInformationItem}
              />
              <SimpleItem
                dataField="AccountName"
                label={{
                  text: localize.getString("accountname"),
                }}
                render={renderInformationItem}
              />
              <SimpleItem
                dataField="Currency"
                label={{
                  text: localize.getString("currency"),
                }}
                render={renderInformationItem}
              />
              <SimpleItem
                dataField="Note"
                label={{
                  text: localize.getString("note"),
                }}
                render={renderInformationItem}
              />
            </GroupItem>
            <GroupItem colCount={2}>
              {data.IndividualAccountDetail !== null && (
                <GroupItem
                  caption={localize.getString("individualAccountDetail")}
                >
                  <SimpleItem
                    dataField="IndividualAccountDetail.PersonalIdentityNumber"
                    label={{
                      text: localize.getString("identitynumber"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="IndividualAccountDetail.Name"
                    label={{
                      text: localize.getString("name"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="IndividualAccountDetail.Surname"
                    label={{
                      text: localize.getString("surname"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="IndividualAccountDetail.Email"
                    label={{
                      text: localize.getString("email"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="IndividualAccountDetail.Phone"
                    label={{
                      text: localize.getString("phone"),
                    }}
                    render={renderInformationItem}
                  />
                </GroupItem>
              )}
              {data.CorporateAccountDetail !== null && (
                <GroupItem
                  caption={localize.getString("corporateAccountDetail")}
                >
                  <SimpleItem
                    dataField="CorporateAccountDetail.AuthorizedPersonName"
                    label={{
                      text: localize.getString("authorizedpersonname"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="CorporateAccountDetail.AuthorizedPersonSurname"
                    label={{
                      text: localize.getString("authorizedpersonsurname"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="CorporateAccountDetail.CorporateEmail"
                    label={{
                      text: localize.getString("email"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="CorporateAccountDetail.CorporatePhone"
                    label={{
                      text: localize.getString("phone"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="CorporateAccountDetail.CorporateRegisteredTaxOffice"
                    label={{
                      text: localize.getString("taxoffice"),
                    }}
                    render={renderInformationItem}
                  />
                  <SimpleItem
                    dataField="CorporateAccountDetail.CorporateRegisteredTaxNumber"
                    label={{
                      text: localize.getString("taxnumber"),
                    }}
                    render={renderInformationItem}
                  />
                </GroupItem>
              )}
            </GroupItem>
            <GroupItem caption={localize.getString("locations")}>
              <DataGrid
                className="create-price-grid"
                dataSource={data.AccountLocations}
                columns={accountLocationColums}
                showBorders
                showRowLines
                rowAlternationEnabled
                showColumnLines={false}
              />
            </GroupItem>
          </GroupItem>
        </Form>
      </form>
    );
  }
);

export default DetailAccountForm;
